export default __webpack_public_path__ + "static/Float_2-00165672893c72ad8f1e7c2bfc17bfbb.mp4";